import React from "react";
import { t } from "i18next";
import Button, { CustomButton } from "./Button";
import { useDispatch } from "react-redux";
import { TranslationText } from "./TextTranslationContainer";

const ErrorModal = ({
  setOpen,
  message,
  children,
  reduxAction,
  btnTitle,
  handleClik,
}) => {
  const dispatch = useDispatch();
  const closeModal = (e) => {
    e && e?.preventDefault?.();
    if (reduxAction) {
      dispatch(reduxAction);
    } else if (setOpen) {
      setOpen(false);
    } else if (handleClik) {
      handleClik();
    }
  };
  if (message === null || message === undefined) return null;
  return (
    <div className="jsutify-center w-full items-center justify-center fixced top-0 left-0 h-app-height modal-mask  overflow-y-auto flex">
      <div className="w-full h-fit mx-4 bg-white rounded-16x">
        <form className="py-8 px-8">
          <div className="text-21x font-bold text-center">{t("Message")}</div>
          <div className="mt-4 mb-2">
            <p className="text-16x text-center">
              {message
                ? t(message)
                : t("We're sorry, but something went wrong. Please try again")}
            </p>
            {children && children}
          </div>
          <div className="flex justify-center">
            <CustomButton
              onClick={closeModal}
              outline={true}
              className="w-fit"
              style={{
                padding: "10px 15px",
                borderRadius: "10px",
              }}
            >
              <TranslationText text={btnTitle || "Close"} />
            </CustomButton>
           
          </div>
        </form>
      </div>
    </div>
  );
};

export default ErrorModal;
